<script>
    import {createEventDispatcher} from "svelte";
    import IconLink from "./icons/IconLink.svelte";

    export let searchTerm;
    export let count = 0;
    export let clickedLetter = false;

   // export let letterClicked

    export let byPeer;

    $: results = count === 1 ? "result" : "results";
    $: noticetype = count > 0 ? "success" : "info";

    const dispatch = createEventDispatcher()

    const handleClick = () => {
        dispatch('copyToClipboard');
    }

</script>
<div class="col mb-4">
<div id="searchSummary" class="alert alert-{noticetype} m-0 d-flex justify-content-between">
    <span class="d-flex justify-content-center align-content-center">
    <h5 id="search-summary"
         class="p-0 m-0 d-flex align-items-center"
         aria-live="polite"
         aria-atomic="true"
         style="display: flex;"
    >
        {#if count === 0}
        <span style="font-weight: 300;">
        No
        </span>&nbsp;
        {:else}
        <span style="font-weight: 300;">
        Found&nbsp;<b>{count}</b>&nbsp;
        </span>
        {/if}
        {#if byPeer}
            <span style="font-weight: 300;">peer-reviewed</span>&nbsp;
        {/if}
        <span style="font-weight: 300;">{results}</span>&nbsp;
        {#if clickedLetter}
            <span style="font-weight: 300;">starting with</span>&nbsp;"{clickedLetter}"
        {:else}
            {#if searchTerm}
                <span style="font-weight: 300;">containing</span>&nbsp;"{@html searchTerm}"&nbsp;
            {:else}
                <span style="font-weight: 300;">total</span>
            {/if}
        {/if}
    </h5>
</span>

    <div class="p-0 d-flex justify-content-end align-items-center">
        <button
                title="Copy URL to clipboard"
                aria-label="Copy URL to clipboard"
                class="small btn bg-cyan text-white btn-sm rounded-2"
                on:click={handleClick}
        ><IconLink
                width="1rem"
                height="1rem"
                fill="#fff"
                padding="--padding-form"
        />
            <span class="sr-only"> Copy URL to clipboard</span></button>
    </div>
</div>
</div>

<style>
    button:hover {
        text-decoration: underline;
    }
</style>